// extracted by mini-css-extract-plugin
export default {"card":"EventCard_card__plWGW","cardOverlay":"EventCard_cardOverlay__vob2l","cardHeader":"EventCard_cardHeader__1zXom","numJoined":"EventCard_numJoined__sng4h"};